' use strict'

import React from 'react';

import FormattedContent from '../components/FormattedContent.jsx';
import Field from '../components/Field3.jsx';

import sendCommand from '../../app/utils/sendCommand.js';

import request from 'superagent';

import Translations from '../../app/utils/translations.js';

let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ]);

class TransitionLink extends React.Component {
  requestPhaseTransition(event) {
    event.preventDefault();
    this.props.onClick(this.props.currentPhase,this.props.nextPhase);
  }

  render() {
    let labels=translations.getTranslation(this.props).general.phaseTransition;
    let nextPhase=this.props.nextPhase;
    return (
      <a onClick={this.requestPhaseTransition.bind(this)} href="#">
        {this.props.endProject===true
          ? this.props.isClosing!==true
            ? ( <span>{labels.prepareClosure}</span> )
            : null
          : (
          <span>
            { this.props.type==="approve"
              ? ( <span>{labels.requestPending} </span> )
              : ( <span>{labels.requestToStart} </span> )
            }
            {nextPhase.text}
          </span>
        )}
      </a>
    );
  }
}

class PhaseTransitionSummary extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.phaseTransition;
    let hasApprovedStage=this.props.project.stages!==undefined && this.props.project.stages.filter(stage=>stage.active===true || stage.history===true).length>0;
    let hasPhases=this.props.projectType!==undefined && this.props.projectType.phases!==undefined && this.props.projectType.phases.length>0;
    let hasStagesOutsidePhase=this.props.schedule.filter(phase=>phase.id==="_project" && phase.items!==undefined && phase.items.length>0)[0]!==undefined;
    let currentCalculatedPhase=this.props.schedule.filter(phase=>phase.items!==undefined && phase.items.filter(item=>item.active===true).length>0)[0];
    var currentPhase=hasPhases
      ? this.props.project.currentPhase !== undefined && hasPhases
        ? this.props.projectType.phases.filter(phase=>phase.id===this.props.project.currentPhase.id)[0]
        : undefined
      : undefined;
    var assumedCurrentPhase=false;
/*
    if (currentPhase===undefined && currentCalculatedPhase!==undefined) {
      currentPhase=currentCalculatedPhase;
      assumedCurrentPhase=true;
    }
*/
    let nextPhase=hasPhases
      ? currentPhase!==undefined
        ? this.props.projectType.phases.slice(this.props.projectType.phases.findIndex(phase=>phase.id===currentPhase.id)).slice(1)[0]
        : this.props.projectType.phases[0]
      : undefined;
    let lastStageInPhase=currentPhase!==undefined && (currentPhase.stages===undefined || currentPhase.stages.length===0 || currentPhase.stages.slice(-1)[0].active===true);
    let hasNextPhase=nextPhase!==undefined;
    let pendingRequest=this.props.project.requestedPhase;
    return this.props.project.isCompleted ? (
      <div><b>Project Completed</b></div>
    )
      : hasPhases ? (
      <div style={{paddingBottom:10, paddingTop:5, fontFamily:"Lato"}}>
        {hasStagesOutsidePhase ? (
          <div style={{color:"#212121", padding:10, marginTop: 10, fontFamily:"Lato", textAlign:"center", backgroundColor:"#FFEADB"}}>{labels.stageOutsidePhases}</div>
        ) : currentPhase!==undefined ? (
          <div>
            {labels.currentPhase}: {currentPhase.text} {assumedCurrentPhase===true ? <span><span style={{color:"red"}}>*</span>(<i>calculated</i>)</span> : null}
            <span> </span>
            <span>
              {pendingRequest!==undefined ? (
                <span style={{paddingLeft:10}}>
                  <img style={{paddingRight:10, verticalAlign:"middle"}} src="/images/Flag_FinishGrey_22x16.gif"/>
                  <TransitionLink
                    {...this.props}
                    type="approve"
                    onClick={this.props.onStartPhase}
                    nextPhase={this.props.projectType.phases.find(phase=>phase.id===pendingRequest.id)}
                    currentPhase={currentPhase}
                  />
                  <div style={{paddingLeft:10, paddingTop:5, fontStyle:"italic"}}>
                    <FormattedContent value={pendingRequest.comments}/>
                  </div>
                </span>
              ) : lastStageInPhase ? (
                hasNextPhase ? (
                  <TransitionLink {...this.props} nextPhase={nextPhase} currentPhase={currentPhase} onClick={this.props.onStartProject}/>
                ) : this.props.project.stages!==undefined && this.props.project.stages.length>0 && this.props.project.stages.slice(-1)[0].active===true
                  ? this.props.project.requestedStageTransition!==undefined ? (
                      <i> Project close is requested</i>
                    ) : (
                      <TransitionLink {...this.props} endProject={true} isClosing={this.props.project.isClosing} currentPhase={currentPhase} onClick={this.props.onStartProject}/>
                    )

                  : null
              ) : "on going"}
            </span>
          </div>
        ) : (
          <div>
            {labels.projectNotStarted}:
            <span> </span>
            {pendingRequest!==undefined ? (
              <span style={{paddingLeft:10}}>
                <img style={{paddingRight:10, verticalAlign:"middle"}} src="/images/Flag_FinishGrey_22x16.gif"/>
                  <TransitionLink
                    {...this.props}
                    type="approve"
                    onClick={this.props.onStartPhase}
                    nextPhase={this.props.projectType.phases.find(phase=>phase.id===pendingRequest.id)}
                    currentPhase={currentPhase}
                  />
                <div style={{paddingLeft:10, paddingTop:5, fontStyle:"italic"}}>
                  <FormattedContent value={pendingRequest.comments}/>
                </div>
              </span>
            ) : (
              <TransitionLink {...this.props} nextPhase={nextPhase} onClick={this.props.onStartProject}/>
            )}
          </div>
        )}
      </div>
    ) : null;
  }
}

export default class PhaseTransition extends React.Component {
  constructor(props) {
    super(props);
    this.state={showStart:false};
  }

  startProject(currentPhase,nextPhase) {
    if (nextPhase===undefined) {
      console.log("Prepare project closure");
      sendCommand({type:"prepareProjectClosure", project: {id: this.props.project.id}})
        .then(()=>window.location="/projects/"+this.props.project.id)
        .catch(error=>{
          console.log("[ERROR] not able to prepare closure, got ",error);
          alert("An error occured, please try again");
        });
    } else {
      this.setState({showStart:true, currentPhase: currentPhase, nextPhase:nextPhase});
    }
  }

  cancelStartProject(event) {
    event.preventDefault();
    this.setState({showStart:false});
  }

  startPhase(currentPhase,nextPhase) {
    console.log("Approve request, current: "+(currentPhase!==undefined ? currentPhase.text : "<udefinert>")+", next:"+(nextPhase!==undefined ? nextPhase.text : "<udefinert>"));
    this.setState({showStartPhase:true, currentPhase: currentPhase, nextPhase:nextPhase});
  }

  requestTransition(event) {
    event.preventDefault();
    if (this.state.nextPhase===undefined) {
      request
        .get("/projects/"+this.props.project.id+"/recommend/close?redirect=false&comments="+event.target.elements.comments.value)
        .then(response=>{
          if (this.props.onUpdate!==undefined) {
            this.props.onUpdate(JSON.parse(response.text).project);
          }
        })
        .catch(error=>{
          console.log("got error",error);
          alert("An error occures, please try again");
        });
    } else {
      sendCommand({
        type:"requestPhaseTransition",
        project: {id: this.props.project.id},
        phase: {id:this.state.nextPhase.id},
        comments: event.target.elements.comments.value
      })
        .then(response=>{
          console.log("New state, recalculate schedule");
          if (this.props.onUpdate!==undefined) {
            this.props.onUpdate(response.project);
          }
        })
        .catch(error=>{
          console.log("[ERROR] An error occured",error);
          alert("An error occured, please try again");
        })
      console.log("Send request to start phase");
    }
    this.setState({showStart:false});
  }

  approveRequest(event) {
    event.preventDefault();
    console.log("Approve phase transition");
    sendCommand({
      type:"approvePhaseTransition",
      project: {id: this.props.project.id},
      phase: {id:this.state.nextPhase.id}
    })
      .then(response=>{
        console.log("New state, recalculate schedule");
        if (this.props.onUpdate!==undefined) {
          this.props.onUpdate(response.project);
        }
      })
      .catch(error=>{
        console.log("[ERROR] An error occured",error);
        alert("An error occured, please try again");
      })
    console.log("Send request to start phase");
    this.setState({showStartPhase:false});
  }

  retractRequest(event) {
    event.preventDefault();
    console.log("Retract phase transition request");
    sendCommand({
      type:"retractPhaseTransition",
      project: {id: this.props.project.id},
      phase: {id:this.state.nextPhase.id}
    })
      .then(response=>{
        console.log("New state, recalculate schedule");
        if (this.props.onUpdate!==undefined) {
          this.props.onUpdate(response.project);
        }
      })
      .catch(error=>{
        console.log("[ERROR] An error occured",error);
        alert("An error occured, please try again");
      })
    console.log("Send request to start phase");
    this.setState({showStartPhase:false});
  }

  cancelPhaseStart(event) {
    event.preventDefault();
    this.setState({showStartPhase:false});
  }

  render() {
    let labels=translations.getTranslation(this.props).general.phaseTransition;
    let nextPhase=this.state.nextPhase!==undefined ? this.state.nextPhase : undefined;
    return this.state.showStartPhase ? (
      <div style={{fontFamily:"Lato"}}>
        {this.state.currentPhase!==undefined ? (
          <div>
            <h2>{labels.requestToEnd} {this.state.currentPhase.text}</h2>
            <FormattedContent value={this.state.currentPhase.description}/>
            {this.state.currentPhase.link!==undefined && this.state.currentPhase.link.trim().length>0 ? (
              <div style={{float:"right"}}><a href={this.state.currentPhase.link} target="_blank">{labels.readMore} {this.state.currentPhase.text} ...</a></div>
            ) : null}
          </div>
        ) : null}
        <h2>{labels.requestToStart} {nextPhase.text}</h2>
        <FormattedContent value={nextPhase.description}/>
        {nextPhase.link!==undefined && nextPhase.link.trim().length>0 ? (
          <div style={{float:"right"}}><a href={nextPhase.link} target="_blank">{labels.readMore} {nextPhase.text} ...</a></div>
        ) : null}
        <div style={{paddingTop:15}}>
          <div>
            <b>{labels.requestComments}</b>
          </div>
          <FormattedContent value={this.props.project.requestedPhase.comments}/>
        </div>
        <form>
          <div style={{paddingTop:15, paddingBottom:20}}>
            <input onClick={this.cancelPhaseStart.bind(this)} className="cancel" type="button" value={labels.cancel}/>
            <div style={{display: "flex", justifyContent:"flex-end"}}>
              <input onClick={this.retractRequest.bind(this)} style={{padding:5, paddingLeft:30, paddingRight: 30, marginRight:40}} className="delete" type="button" name="delete" value={labels.retractRequest}/>
              <input onClick={this.approveRequest.bind(this)} className="save" type="button" value={labels.approveRequest}/>
            </div>
          </div>
        </form>
      </div>

    ) : this.state.showStart ? (
      <div style={{fontFamily:"Lato", paddingBottom:10}}>
        {this.state.currentPhase!==undefined ? (
          <div>
            <h2>{labels.requestToEnd} {this.state.currentPhase.text}</h2>
            <FormattedContent value={this.state.currentPhase.description}/>
            {this.state.currentPhase.link!==undefined && this.state.currentPhase.link.trim().length>0 ? (
              <div style={{float:"right"}}><a href={this.state.currentPhase.link} target="_blank">{labels.readMore} {this.state.currentPhase.text} ...</a></div>
            ) : null}
          </div>
        ) : null}
        {nextPhase!==undefined ? (
          <div>
            <h2>{labels.requestToStart} {nextPhase.text}</h2>
            <FormattedContent value={nextPhase.description}/>
            {nextPhase.link!==undefined && nextPhase.link.trim().length>0 ? (
              <div style={{float:"right"}}><a href={nextPhase.link} target="_blank">{labels.readMore} {nextPhase.text} ...</a></div>
            ) : null}
          </div>
        ) : (
          <div>
            <h2>Request to end project</h2>
            <p>
              Before closure of the project can be recommended, the Project Manager must ensure that the expected results have all been achieved and delivered.
            </p>
            <p>
              Key results:
              <ul>
                <li>Products are handed over and accepted by the receiving organization(s)</li>
                <li>Project is evaluated and lessons recorded.</li>
              </ul>
            </p>
            <p>
              Summarized in:
              <ul>
                <li>End Project Report</li>
                <li>Updated Lessons Log</li>
              </ul>
            </p>
          </div>
        )}
        <form onSubmit={this.requestTransition.bind(this)}>
          <div style={{paddingTop:15}}>
            <Field name="comments" title={labels.requestComments} height={2} optional={true}/>
          </div>
          <div style={{paddingTop:15, paddingBottom:20}}>
            <input onClick={this.cancelStartProject.bind(this)} className="cancel" type="button" value={labels.cancel}/>
            <input className="save" type="submit" value={labels.submitRequest}/>
          </div>
        </form>
      </div>
    ) : (
      <PhaseTransitionSummary
        {...this.props}
        onStartProject={this.startProject.bind(this)}
        onStartPhase={this.startPhase.bind(this)}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./views/plan/PhaseTransition.jsx